/** Performance mark recorded once a vault list has first rendered, shared by all clients. */
export const VAULT_RENDERED_MARK = "Vault rendered";
